import { render, staticRenderFns } from "./AttributeImageSelector.vue?vue&type=template&id=60b11a46&scoped=true"
import script from "./AttributeImageSelector.vue?vue&type=script&lang=js"
export * from "./AttributeImageSelector.vue?vue&type=script&lang=js"
import style0 from "./AttributeImageSelector.vue?vue&type=style&index=0&id=60b11a46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b11a46",
  null
  
)

export default component.exports